import React from 'react';
import Modal from 'Shared/components/Modal';

type AccessibilityStandardsModalProps = {
  onClose: () => void;
  open: boolean;
};

const AccessibilityStandardsModal = (props: AccessibilityStandardsModalProps) => (
  <Modal maxWidth="md" open={props.open} title="Accessibility Statement" onClose={props.onClose}>
    <div className="login__legal-disclaimer">
      <h1>Website Accessibility Statement</h1>
      At The Standard, inclusive diversity is one of our core values. We believe in making our website easy to use
      for all people, including those with disabilities.
      <br />
      <br />
      <h2>Online Accessibility</h2>
      <p>
        In order to provide excellent service to all of our customers, including those with disabilities, The Standard
        website strives to provide an accessible experience for users of all abilities. The Standard is
        working to develop our website with accessibility in mind. Our improvements are guided by relevant portions of
        the Web Content Accessibility Guidelines 2.0, Level AA and other recommendations. We will be including
        accessibility features such as: improved navigability without use of a keyboard, text alternatives for non-text
        content, and assigned language for web pages. We test our website periodically using automated tools and
        assistive technology.
      </p>
      <p>
        If you have questions or concerns about the accessibility of our website, please contact us by sending an email
        to MyAccess@standard.com or calling us at 1-800-521-3535. Please provide specific details about the
        accessibility issue, including the web address that may have caused challenges.
      </p>
      <br />
      <h2>Reasonable Accommodations</h2>
      <p>
        Individuals who need a reasonable accommodation to access The Standard's products and services can make a
        request via email to MyAccess@standard.com or by calling 1-800-521-3535. Be sure to include contact
        information such as an email address or telephone number where you can be reached. Depending on the request,
        The Standard may need sufficient notice to provide a reasonable accommodation.
      </p>
      <br />
      <h2>Third-Party Websites</h2>
      <p>
        The Standard’s website may contain links to websites hosted by third parties. The Standard does not
        make claims regarding the accessibility of third-party websites and is not able to make accommodations on such
        websites.
      </p>
      <br />
      <h2>Feedback</h2>
      <p>
        We are always working to ensure that our products and services are accessible to users of all abilities. If you
        have a suggestion or question about accessibility of services at The Standard, please contact
        1-800-521-3535 or MyAccess@standard.com.
      </p>
      <br />
      <p>
        <small>
          This website is provided on as "as is" basis. To the extent permitted by law, The Standard disclaims all
          warranties, express or implied, including, but not limited to, implied warranties of merchantability and
          fitness for a particular purpose. The Standard does not warrant that the functionality or operation of
          the The Standard web site will be uninterrupted or free from error, that any defects in the web site will
          be corrected, or that the web site or the server(s) that makes it available are free of viruses or other
          harmful conditions or components.
        </small>
      </p>
      <p>
        <small>
          The Standard is the marketing name used by American Heritage Life Insurance Company (Home Office,
          Jacksonville, FL). © 2025 StanCorp Financial Group, Inc.
          www.standard.com/ahl
        </small>
      </p>
      
    </div>
  </Modal>
);

export default AccessibilityStandardsModal;
